export default "__VITE_ASSET__BXc0twve__"